var techniques_block = document.querySelector(".techniques") || false;
var description_block = document.querySelector(".description_data") || false;
var returns_block = document.querySelector(".returns") || false;

/*
var shipping_block = document.querySelector(".free_shipping_pdp") || false;
if(shipping_block){
    document.querySelector(".free_shipping_pdp").addEventListener("click", function(e){ 
        e.preventDefault();
        e.stopImmediatePropagation();
        document.querySelector(".livraison-gratuite").classList.add("active");
        document.querySelector("body").classList.add("scroll_lock_enable");
    });
}
*/

document.addEventListener("click", function (e) {
  
    let shipping_block = e.target.closest(".free_shipping_pdp");
    if (shipping_block) {
        e.preventDefault();
        e.stopImmediatePropagation();
        let livraisonElement = document.querySelector(".livraison-gratuite");
        if (livraisonElement) {
            livraisonElement.classList.add("active");
        }
        document.body.classList.add("scroll_lock_enable");
    }
  
});


if (techniques_block) {
  document.querySelector(".techniques").addEventListener("click", function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    document
      .querySelector(".caracéristiques-techniques")
      .classList.add("active");
    document.querySelector("body").classList.add("scroll_lock_enable");
  });
}
if (description_block) {
  document
    .querySelector(".description_data")
    .addEventListener("click", function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      document.querySelector(".description-popup").classList.add("active");
      document.querySelector("body").classList.add("scroll_lock_enable");
    });
}


document.addEventListener("click", function (e) {
  if (e.srcElement.className == "overlay") {
    var popup_wrapper = document.getElementsByClassName(
      "product-popup-wrapper"
    );
    for (let i = 0; i < popup_wrapper.length; i++) {
      popup_wrapper[i].classList.remove("active");
    }
    
    //document.querySelector(".site-header__cart").classList.remove("is-active");
    //document.querySelector(".site-header__cart").classList.remove("is-transitioning");
    document.querySelector("body").classList.remove("scroll_lock_enable");
    
  }

  if (e.target.classList.contains("close-btn_btn")) {
    e.preventDefault();
    e.stopImmediatePropagation();

    // Find all popup wrappers and remove the 'active' class
    var popup_wrappers = document.getElementsByClassName("product-popup-wrapper");
    for (let i = 0; i < popup_wrappers.length; i++) {
      popup_wrappers[i].classList.remove("active");
    }

    // Remove scroll lock from body
    document.body.classList.remove("scroll_lock_enable");
  }

  if (e.target.classList.contains("close-btn_btn")) {
    e.preventDefault();
    e.stopImmediatePropagation();

    // Find all popup wrappers and remove the 'active' class
    var popup_wrappers = document.getElementsByClassName("product-popup-wrapper");
    for (let i = 0; i < popup_wrappers.length; i++) {
      popup_wrappers[i].classList.remove("active");
    }

    // Remove scroll lock from body
    document.body.classList.remove("scroll_lock_enable");
  }
  
});

if (document.querySelector(".visualise_in_3d")) {
  document
    .querySelector(".visualise_in_3d")
    .addEventListener("click", function () {
      document.querySelector(".custom_3d_model_container").style.display =
        "block";
      document
        .querySelector(".custom_3d_model-main_main")
        .classList.add("popup_active");
      document.querySelector("body").classList.add("scroll_lock_enable");
    });
}
if (document.querySelector(".custom_3d_model_popup_close_btn")) {
  document
    .querySelector(".custom_3d_model_popup_close_btn")
    .addEventListener("click", function () {
      document.querySelector(".custom_3d_model_container").style.display =
        "none";
      document
        .querySelector(".custom_3d_model-main_main")
        .classList.remove("popup_active");
      document.querySelector("body").classList.remove("scroll_lock_enable");
    });
}
if(returns_block){
    document.querySelector(".returns").addEventListener("click", function(e){ 
        e.preventDefault();
        e.stopImmediatePropagation();
        document.querySelector(".retour-garantie").classList.add("active");
        document.querySelector("body").classList.add("scroll_lock_enable");
    });
}

// MegaMenu hover open the submenu
let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
items.forEach(item => {
  item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
});